import { PlanFeature as PlanFeatureType, PlanOffering } from '../../../plan.types';
import { PlanFeaturesItemOfferingContainer } from './plan-features-item-offering.styles';

import CHECKMARK_ICON from '/public/icons/eva/checkmark.svg';
import CLOSE_ICON from '/public/icons/eva/close.svg';

type PlanFeaturesItemOfferingProps = {
  feature: PlanFeatureType;
  offering: PlanOffering;
};

export default function PlanFeaturesItemOffering({ feature, offering }: PlanFeaturesItemOfferingProps) {
  return (
    <PlanFeaturesItemOfferingContainer>
      {!!feature.offerings.find((o) => o.name === offering.name)?.description ? (
        <div className="description">{feature.offerings.find((o) => o.name === offering.name)?.description}</div>
      ) : feature.offerings.map((o) => o.name).includes(offering.name) ? (
        <CHECKMARK_ICON className="included" />
      ) : (
        <CLOSE_ICON className="not-included" />
      )}
    </PlanFeaturesItemOfferingContainer>
  );
}
